export const NFT_SUB_GRAPH_URL = 'https://nftgraphql.yetiswap.app/subgraphs/name/yetiswap/nftmarket2'
export const NFT_ERC721_GRAPH_URL = 'https://nftgraphql.yetiswap.app/subgraphs/name/yetiswap/avalanche-erc721'
